import {checkCodeActionInputAndAddPoints} from "./checkCodeActionInputAndAddPoints";
import {redirectToLogin} from "../utils/redirectToLogin.js";

export function submitCodeForCodeAction(target) {
    var date = target.closest(".timeline_entry").find('.expiry_date').text();
    var dateArray = date.split(".");
    date = stringToDate(dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0] + " 23:59:59");
    var currDate = new Date();

    if (date >= currDate) {
        if (shopUserId !== "") {
            var input = target.closest(".red_border_code_line").find("input");
            var code = input.val();
            code = code.replace(";", "");
            code = code.replace(" ", "");
            if (code !== "" && code !== undefined) {
                var id = input.attr("id").split("_")[4];

                if (code.length === 9) {
                    var first = code.substring(0, 3);
                    var second = code.substring(3, 6);
                    var third = code.substring(6, 9);
                    code = first + ";" + second + ";" + third;
                }

                checkCodeActionInputAndAddPoints(id, code, input);
            }
        } else {
            redirectToLogin();
        }
    } else {
        alert("Die Code Aktion ist bereits abgelaufen!");
    }
}